// YouTube API service for handling private video authentication
const YOUTUBE_API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY  || "AIzaSyCcMqZSfNMzppF_mBbShXGPqp4-HCYbkc8";
export const getAuthenticatedVideoUrl = async (videoId) => {
  try {
    // Method 1: Try to get video info using YouTube Data API
    const response = await fetch(
      `https://www.googleapis.com/youtube/v3/videos?id=${videoId}&key=${YOUTUBE_API_KEY}&part=snippet,status`
    );
    const data = await response.json();

    if (data.items && data.items.length > 0) {
      const video = data.items[0];

      // Check if video is private or unlisted
      if (video.status.privacyStatus === 'private') {
        // For private videos, we need OAuth2 authentication
        return await getOAuthVideoUrl(videoId);
      } else {
        // Public or unlisted videos can be embedded normally
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }

    // Fallback to public embed URL
    return `https://www.youtube.com/embed/${videoId}`;
  } catch (error) {
    console.error('Error getting video URL:', error);
    return `https://www.youtube.com/embed/${videoId}`;
  }
};

const getOAuthVideoUrl = async (videoId) => {
  try {
    // This would require implementing OAuth2 flow
    // For now, return the standard embed URL
    // The user will need to be logged into YouTube with appropriate permissions
    return `https://www.youtube.com/embed/${videoId}`;
  } catch (error) {
    console.error('OAuth error:', error);
    return `https://www.youtube.com/embed/${videoId}`;
  }
};

// Alternative method: Use YouTube IFrame API with authentication
export const createAuthenticatedPlayer = (videoId, elementId, onReady) => {
  // Load YouTube IFrame API
  if (!window.YT) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  // Initialize player when API is ready
  window.onYouTubeIframeAPIReady = () => {
    new window.YT.Player(elementId, {
      height: '200',
      width: '300',
      videoId: videoId,
      playerVars: {
        // Add authentication parameters here if needed
        origin: window.location.origin,
      },
      events: {
        onReady: onReady
      }
    });
  };
};
